/**
 * In-memory cache для SSR. Включается через env USE_MEMORY_CACHE=true.
 * Простая обёртка: ключ (строка) и сброс (boolean).
 */

const cache = new Map<string, unknown>();

function isMemoryCacheEnabled(): boolean {
  return process.env.USE_MEMORY_CACHE === "true";
}

/**
 * Кеширует результат getData() по ключу. При reset=true кеш по ключу сбрасывается.
 *
 * @param getData — функция без аргументов, возвращающая Promise с данными
 * @param key — строка-ключ кеша
 * @param reset — сбросить кеш и запросить данные заново
 */
export async function withMemoryCache<T>(
  getData: () => Promise<T>,
  key: string,
  reset: boolean,
): Promise<T> {
  if (!isMemoryCacheEnabled()) {
    return getData();
  }

  if (reset) {
    cache.delete(key);
  } else {
    const cached = cache.get(key);
    if (cached !== undefined) {
      return cached as T;
    }
  }

  const result = await getData();
  cache.set(key, result);
  return result;
}
